export { DsDefaultIconsModule } from './src/default-icons.module';
export { DsIconComponent } from './src/components/icon/icon.component';
